import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';
import { authAPI } from '@/lib/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUserData } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionId = hash.split('session_id=')[1]?.split('&')[0];

      if (!sessionId) {
        navigate('/login', { replace: true });
        return;
      }

      try {
        const res = await authAPI.session(sessionId);
        const { user, session_token } = res.data;
        setUserData(user, session_token);

        // Clean the hash and redirect
        window.history.replaceState(null, '', '/dashboard');
        navigate('/dashboard', { replace: true, state: { user } });
      } catch (err) {
        const msg = err.response?.data?.detail || 'Sign-in failed. Please try again.';
        console.error('Auth callback error:', err);
        navigate('/login', { replace: true, state: { authError: msg } });
      }
    };

    processAuth();
  }, [navigate, setUserData]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="h-12 w-12 rounded-xl bg-primary/20 mx-auto mb-4 animate-pulse" />
        <p className="text-muted-foreground">Authenticating...</p>
      </div>
    </div>
  );
}
